var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useResizeObserver } from '../hooks/use-resize-observer';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
export var TextLoop = function TextLoop(props) {
  var className = props.className,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 3000 : _props$duration,
    durationOn1000px = props.durationOn1000px,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? 10 : _props$spacing,
    _props$play = props.play,
    play = _props$play === void 0 ? false : _props$play,
    children = props.children,
    divProps = __rest(props, ["className", "duration", "durationOn1000px", "spacing", "play", "children"]);
  var wrapRef = useRef(null);
  var textRef = useRef(null);
  var _useState = useState({
      width: 1,
      height: 1
    }),
    wrapSize = _useState[0],
    setWraperSize = _useState[1];
  var _useState2 = useState({
      width: 1,
      height: 1
    }),
    textSize = _useState2[0],
    setTextSize = _useState2[1];
  useEffect(function () {
    setTimeout(function () {
      setTextSize(function (prev) {
        var _a, _b;
        return (_b = (_a = textRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : prev;
      });
      setWraperSize(function (prev) {
        var _a, _b;
        return (_b = (_a = wrapRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : prev;
      });
    }, 0);
  }, []);
  var textWidth = textSize.width + spacing;
  var playing = play && wrapSize.width < textWidth;
  var totalTime = durationOn1000px ? textWidth * durationOn1000px / 1000 / 1000 : duration / 1000;
  var animationStyle = playing ? {
    animation: "".concat(totalTime, "s linear 0s infinite running loop")
  } : {};
  useResizeObserver(function () {
    setTextSize(function (prev) {
      var _a, _b;
      return (_b = (_a = textRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : prev;
    });
    setWraperSize(function (prev) {
      var _a, _b;
      return (_b = (_a = wrapRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : prev;
    });
  }, wrapRef);
  return _jsxs("div", Object.assign({}, divProps, {
    ref: wrapRef,
    style: {
      height: textSize.height
    },
    className: classNames(className, 'relative overflow-hidden ')
  }, {
    children: [_jsxs("div", Object.assign({
      className: 'absolute top-0 left-0 min-w-full whitespace-nowrap',
      style: Object.assign(Object.assign({}, animationStyle), {
        height: textSize.height,
        width: textWidth
      })
    }, {
      children: [_jsx("span", Object.assign({
        ref: textRef,
        style: {
          paddingRight: spacing
        }
      }, {
        children: children
      })), playing && _jsx("span", {
        children: children
      })]
    })), _jsx("style", {
      children: "\n                @keyframes loop {\n                    from {\n                        transform: translateX(0);\n                    }\n                    to {\n                        transform: translateX(-100%);\n                    }\n                }\n            "
    })]
  }));
};